import { useEffect } from 'preact/hooks';

/*
  Based on https://usehooks.com/useKeyPress/
  and further discussion https://gist.github.com/gragland/b61b8f46114edbcf2a9e4bd5eb9f47f5
*/

const useEscKeyDown = (callback) => {
  const targetKey = 'Escape';

  useEffect(() => {
    function handleKeyDown({ key }) {
      if (key === targetKey) {
        callback();
      }
    }

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [callback]);
};

export default useEscKeyDown;
